import { Div } from '../../../base/components/native/div'
import { IRouteParams } from '../../../base/lib/router'
import emitter from '../../../base/utils/emitter'
import { waitFor } from '../../../base/utils/wait'
import helpers from '../../../helpers'
import { IProductVariant } from '../../../interfaces/product'
import services from '../../../services'
import { PageContents } from '../../shared/page-contents'
import { HomeHeader } from '../home/home-header'
import { ProductBlock } from '../home/product-block/product-block'
import { Product } from './product'


export const ProductPage = () => {

    const base = Div()
    const header = HomeHeader()
    const titles = Div()

    const contents = PageContents()

    base.append(header, titles, contents)
    base.cssClass({ ...helpers.styles.PAGE_BASE_STYLE })
    titles.cssClass({
        marginTop: '60px',
        paddingTop: '60px',
        backgroundColor: '#F7F7F7',
        textAlign: 'center',
    })
    contents.cssClass({
        overflowX: 'scroll',
        overflowY: 'hidden',
        scrollSnapStop: 'always',
        scrollSnapType: 'x mandatory',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    })
    emitter.on('route-changed', (to: string) => {
        if (location.hash === '#/cart') {
            base.style(helpers.styles.PAGE_EXIT_UP_STYLE, 100)
        }
    })

    function exit({ to }: IRouteParams) {
        // if (to?.includes('/product#')) return
        base.style(helpers.styles.PAGE_EXIT_UP_STYLE)
        if (to === '/') {
            base.style(helpers.styles.PAGE_EXIT_UP_STYLE)
        }
    }

    async function enter({ query, from, to, data, route }: IRouteParams) {
        if (to?.includes('/product#')) return base.style(helpers.styles.PAGE_EXIT_UP_STYLE)
        await waitFor(300)
        base.style(helpers.styles.PAGE_ENTER_STYLE)
        const product = query['id']
        const color = query['color']
        const block = ProductBlock(product, color)
        base.append(block)
        block.render()


    }

    return Object.assign(base, { enter, exit })
}